import { render, staticRenderFns } from "./ovningsblad-dyn.vue?vue&type=template&id=0c89a2bd&scoped=true"
import script from "./ovningsblad-dyn.vue?vue&type=script&lang=js"
export * from "./ovningsblad-dyn.vue?vue&type=script&lang=js"
import style0 from "./ovningsblad-dyn.vue?vue&type=style&index=0&id=0c89a2bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89a2bd",
  null
  
)

export default component.exports